<form [formGroup]="idForm" autocomplete="off" (ngSubmit)="onSubmit()">
	<div class="form-group" [ngClass]="{'is-form-error': getIdForm.username.errors }">
		<label for="username"><strong>{{ 'pages.identification.form.username' | translate }}</strong></label>
		<div class="input-content">
			<input type="text" class="form-item form-item-login" id="username" formControlName="username" aria-required="true" aria-invalid="false" aria-describedBy="username-desc">
			<span *ngIf="getIdForm.username.errors" id="user-alert" aria-hidden="true" class="icon icon--alert"></span>
		</div>
		<span *ngIf="getIdForm.username.errors" class="is-form-error" id="username-desc">{{ identificationErrorKey | translate }}</span>
    <p class="text-small" innerHTML="{{ 'pages.identification.help-alternate-email' | translate }}"></p>
	</div>
	<div *ngIf="showCaptcha" class="form-group g-recaptcha-scale">
    <ngx-recaptcha2
      (success)="resolved($event)"
      (expire)="expired()"
      [siteKey]="gRecaptchaSiteKey"
      [hl]="gLang()"
      formControlName="recaptcha">
    </ngx-recaptcha2>
  </div>
  <div *ngIf="!loading">
    <button type="submit" [disabled]="!formValid()" class="btn btn--primary mr-1" tabindex="0">{{ 'buttons.recover' | translate }}</button>
    <a attr.href="{{ 'links.uoc.url' | translate }}" class="text-small" tabindex="0">{{ 'links.uoc.name' | translate }}</a>
  </div>
  <div class="spinner-wrapper">
    <img src="assets/img/spinner.gif" class="loading" alt="{{ 'app.loading' | translate }}" *ngIf="loading">
  </div>
</form>


